import { useEffect } from 'react';

// Whether a page of the site has been shown in this window: every later one
// arrived by an Inertia visit. One flag for the marketing shell and the
// example passport page, so a visit between them counts as one.
let shownBefore = false;

/**
 * After an Inertia visit the link that led here has gone with the old page,
 * leaving the focus on the body: the new page's main region (the element
 * with `id`, focusable with tabIndex={-1}) takes it, without a scroll, so a
 * screen reader reads where it is and Tab starts from the page (audit 40).
 * A first load leaves the focus where the browser put it, and a page that
 * put the focus somewhere itself keeps it.
 */
export default function useFocusOnVisit(id) {
    useEffect(() => {
        if (shownBefore && document.activeElement === document.body) {
            document.getElementById(id)?.focus({ preventScroll: true });
        }
        shownBefore = true;
    }, [id]);
}
